<template>
  <div>
    <new-allMaintain showingPage="allMaintain"></new-allMaintain>
  </div>
</template>

<script>
import infoList from '../../../components/newspaperInfoList.vue' 
/**
 *@ClassName:projectWideRepoInfoList
 *@Description:全项目报事信息
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-04-16
 */
export default {
  name:'/manage/main.allMaintain',
  components: {
    'new-allMaintain': infoList 
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
  
},
}
</script>
<style lang='scss'>
 
</style>
